import { useRef, useState, useEffect } from 'react';
import Headers from './Headers';
import Axios from '../api/axios';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { MDBContainer } from 'mdbreact';

export const StoreExpensesDetailed = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  const [DBtableViewExpenses, setDBtableViewExpenses] = useState([]);
  const [expensesStore, setDBtableViewExpensesStore] = useState('');

  // Reference to the table element
  const tableRef = useRef(null);

  useEffect(() => {
    var formDataViewExpenses = new FormData();
    formDataViewExpenses.append('apiType', 'getViewExpensesDayClose');
    formDataViewExpenses.append('expenseID', '');
    formDataViewExpenses.append('businessNameID', localStorage.getItem('systemSetupID'));
    formDataViewExpenses.append('businessBranchNameID', localStorage.getItem('systemSetupBranchID'));

    Axios({
      method: 'post',
      url: `${server_app_api_php}/index.php`,
      data: formDataViewExpenses,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      setDBtableViewExpenses(response.data);
      // Initialize DataTable after data is set
      if (tableRef.current) {
        $(tableRef.current).DataTable();
      }
    });
  }, []);

  useEffect(() => {
    // Cleanup function to destroy DataTable when component unmounts
    return () => {
      if (tableRef.current) {
        $(tableRef.current).DataTable().destroy(true);
      }
    };
  }, [DBtableViewExpenses]);

  return (
    <>
      <title>
        KANCH INNOVATIVE TECHNOLOGIES - View Detailed Store Expenses -{' '}
        {localStorage.getItem('systemSetupBranchIDStoreName')}
      </title>
      <Headers />
      
      {/* Preloader */}
      <div className="col-12">
        <main>
          <div className="container-fluid">
            <section className="section mt-5">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="card mb-4">
                    <div className="card-body" style={{ overflowX: 'auto' }}>
                      <h6 className="form-header white-text ocean blue-gradient mt-0 text-uppercase">
                        STORE EXPENSES - DETAILED {expensesStore}
                      </h6>

                      {/* DataTable */}
                      <table
                        ref={tableRef}
                        className="table table-striped table-bordered table-hover table-sm nowrap"
                        width="100%"
                      >
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Store</th>
                            <th>Store Expense</th>
                            <th>Amount</th>
                            <th>Time</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>User</th>
                          </tr>
                        </thead>
                        <tbody>
                          {DBtableViewExpenses.map((expense, index) => (
                            <tr key={expense.store_expensesID}>
                              <td>{index + 1}</td>
                              <td>{expense.store}</td>
                              <td>{expense.store_expense}</td>
                              <td>{expense.amount}</td>
                              <td>{expense.time}</td>
                              <td>{expense.date}</td>
                              <td>{expense.transaction_status}</td>
                              <td>{expense.user}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
export default StoreExpensesDetailed
